// fetchWithCSRF wraps fetch() and automatically adds the CSRF token header
// from the page's meta tag. Use this for all state-changing requests (POST, PATCH, DELETE).
export async function fetchWithCSRF(url, options = {}) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
        options.headers = {
            ...options.headers,
            "X-CSRF-TOKEN": csrfToken,
        }
    }
    const response = await fetch(url, options)

    // Update CSRF token if the server rotated it
    const rotatedToken = response.headers.get("x-csrf-token")
    if (rotatedToken) {
        const meta = document.querySelector('meta[name="csrf-token"]')
        if (meta) {
            meta.content = rotatedToken
        }
    }

    return response
}
